import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams, ToastController } from 'ionic-angular';
import { MenuServices } from "../../services";
import { Globals } from "../../../../globals";
import { ConfigurationServices } from '../../../configuration/services';
import { TranslateService } from '@ngx-translate/core';
import { MenuCreateSelectTypePage } from '../menu-create-select-type/menu-create-select-type';
import { AddonsTriggerVersionProPage } from '../../../addons/addons-trigger-version-pro/addons-trigger-version-pro';
import { AnalyticsServices } from '../../../services/analyticsServices';


@Component({
  selector: 'page-menu-create-select-template',
  templateUrl: 'menu-create-select-template.html',
})
export class MenuCreateSelectTemplatePage {

  template: any = "";
  update_state: boolean = false;
  menu_uid: any;
  menu_name: any;
  show_prices: boolean;
  new_menu: boolean = false;
  template_array = [
    {
      name: 'multipla',
      src: './assets/templates/multipla.jpg'
    },
    {
      name: 'camaro',
      src: './assets/templates/camaro.jpg'
    },
    {
      name: 'challenger',
      src: './assets/templates/challenger.jpg'
    },
    {
      name: 'firebird',
      src: './assets/templates/firebird.jpg'
    },
    {
      name: 'ford-focus',
      src: './assets/templates/focus_min.jpg'
    },
    {
      name: 'audi',
      src: './assets/templates/audi_min.jpg'
    },
    {
      name: 'audi-a1',
      src: './assets/templates/audi_a1.png'
    },
    {
      name: 'mercedes',
      src: './assets/templates/mercedes_min.png'
    },
    {
      name: 'tiguan',
      src: './assets/templates/tiguan.png'
    },
    {
      name: '500',
      src: './assets/templates/500.jpg'
    },
    {
      name: 'c3',
      src: './assets/templates/C3.jpg'
    },
    {
      name: 'clio',
      src: './assets/templates/clio.jpg'
    },
    {
      name: 'ford-focus-black',
      src: './assets/templates/fordfocusblack.jpg'
    },
    {
      name: 'golf',
      src: './assets/templates/golf.jpg'
    },
    {
      name: 'mustang',
      src: './assets/templates/mustang.jpg'
    },
    {
      name: 'new-beetle',
      src: './assets/templates/new-beetle.jpg'
    },
    {
      name: 'r5',
      src: './assets/templates/r5.jpg'
    },
    {
      name: 'ribiera',
      src: './assets/templates/ribiera.jpg'
    },
    {
      name: 'transam',
      src: './assets/templates/transam.jpg'
    },
    {
      name: 'l200',
      src: './assets/templates/L200.jpg'
    },
    {
      name: 'wrangler',
      src: './assets/templates/wrangler.jpg'
    },
  ];

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public menuServices: MenuServices,
    public globals: Globals,
    public toastCtrl: ToastController,
    public configurationServices: ConfigurationServices,
    public translate: TranslateService,
    public analyticsServices: AnalyticsServices) {

    //Params
    this.update_state = this.navParams.get('update_state');
    this.menu_uid = this.navParams.get('menu_uid');
    this.template = this.navParams.get('template_name');
    this.menu_name = this.navParams.get('menu_name');
    this.new_menu = this.navParams.get('new_menu');

    if (!this.update_state) { //Si create y FREE
      this.template = 'multipla';
    }
  }

  ionViewWillEnter() {
    if (this.globals.checkLimitsByLicense('daily_menu', 'templates') != -1) {
      this.changeClass();
    }
  }

  changeClass() {
    //Ponemos filtro gris a las plantillas que la version no puede usar
    const templates = document.getElementsByClassName('template');
    for (let i = this.globals.checkLimitsByLicense('daily_menu', 'templates'); i < templates.length; i++) {
      const slide = templates[i] as HTMLElement;
      slide.style.filter = "grayscale(1)";
    }
  }

  select(type) {
    switch (type) {
      case 'multipla':
        this.template = type;
        break;
      case 'camaro':
        if (this.globals.checkLimitsByLicense('daily_menu', 'templates') == 1) { //Si FREE
          this.navCtrl.push(AddonsTriggerVersionProPage);
        } else {
          this.template = type;
        }
        break;
      case 'challenger':
        if (this.globals.checkLimitsByLicense('daily_menu', 'templates') == 1) { //Si FREE
          this.navCtrl.push(AddonsTriggerVersionProPage);
        } else {
          this.template = type;
        }
        break;
      case 'firebird':
        if (this.globals.checkLimitsByLicense('daily_menu', 'templates') == 1) { //Si FREE
          this.navCtrl.push(AddonsTriggerVersionProPage);
        } else {
          this.template = type;
        }
        break;
      case 'ford-focus':
        if (this.globals.checkLimitsByLicense('daily_menu', 'templates') == 1) { //Si FREE
          this.navCtrl.push(AddonsTriggerVersionProPage);
        } else {
          this.template = type;
        }
        break;
      case 'audi':
        if (this.globals.checkLimitsByLicense('daily_menu', 'templates') == 1) { //Si FREE
          this.navCtrl.push(AddonsTriggerVersionProPage);
        } else {
          this.template = type;
        }
        break;
      case 'audi-a1':
        if (this.globals.checkLimitsByLicense('daily_menu', 'templates') == 1) { //Si FREE
          this.navCtrl.push(AddonsTriggerVersionProPage);
        } else {
          this.template = type;
        }
        break;
      case 'mercedes':
        if (this.globals.checkLimitsByLicense('daily_menu', 'templates') == 1) { //Si FREE
          this.navCtrl.push(AddonsTriggerVersionProPage);
        } else {
          this.template = type;
        }
        break;
      case 'tiguan':
        if (this.globals.checkLimitsByLicense('daily_menu', 'templates') != -1) { //Si NO BUSINESS
          this.navCtrl.push(AddonsTriggerVersionProPage);
        } else {
          this.template = type;
        }
        break;
      case '500':
        if (this.globals.checkLimitsByLicense('daily_menu', 'templates') != -1) { //Si NO BUSINESS
          this.navCtrl.push(AddonsTriggerVersionProPage);
        } else {
          this.template = type;
        }
        break;
      case 'c3':
        if (this.globals.checkLimitsByLicense('daily_menu', 'templates') != -1) { //Si NO BUSINESS
          this.navCtrl.push(AddonsTriggerVersionProPage);
        } else {
          this.template = type;
        }
        break;
      case 'clio':
        if (this.globals.checkLimitsByLicense('daily_menu', 'templates') != -1) { //Si NO BUSINESS
          this.navCtrl.push(AddonsTriggerVersionProPage);
        } else {
          this.template = type;
        }
        break;
      case 'ford-focus-black':
        if (this.globals.checkLimitsByLicense('daily_menu', 'templates') != -1) { //Si NO BUSINESS
          this.navCtrl.push(AddonsTriggerVersionProPage);
        } else {
          this.template = type;
        }
        break;
      case 'golf':
        if (this.globals.checkLimitsByLicense('daily_menu', 'templates') != -1) { //Si NO BUSINESS
          this.navCtrl.push(AddonsTriggerVersionProPage);
        } else {
          this.template = type;
        }
        break;
      case 'mustang':
        if (this.globals.checkLimitsByLicense('daily_menu', 'templates') != -1) { //Si NO BUSINESS
          this.navCtrl.push(AddonsTriggerVersionProPage);
        } else {
          this.template = type;
        }
        break;
      case 'new-beetle':
        if (this.globals.checkLimitsByLicense('daily_menu', 'templates') != -1) { //Si NO BUSINESS
          this.navCtrl.push(AddonsTriggerVersionProPage);
        } else {
          this.template = type;
        }
        break;
      case 'r5':
        if (this.globals.checkLimitsByLicense('daily_menu', 'templates') != -1) { //Si NO BUSINESS
          this.navCtrl.push(AddonsTriggerVersionProPage);
        } else {
          this.template = type;
        }
        break;
      case 'ribiera':
        if (this.globals.checkLimitsByLicense('daily_menu', 'templates') != -1) { //Si NO BUSINESS
          this.navCtrl.push(AddonsTriggerVersionProPage);
        } else {
          this.template = type;
        }
        break;
      case 'transam':
        if (this.globals.checkLimitsByLicense('daily_menu', 'templates') != -1) { //Si NO BUSINESS
          this.navCtrl.push(AddonsTriggerVersionProPage);
        } else {
          this.template = type;
        }
        break;
      case 'l200':
        if (this.globals.checkLimitsByLicense('daily_menu', 'templates') != -1) { //Si NO BUSINESS
          this.navCtrl.push(AddonsTriggerVersionProPage);
        } else {
          this.template = type;
        }
        break;
      case 'wrangler':
        if (this.globals.checkLimitsByLicense('daily_menu', 'templates') != -1) { //Si NO BUSINESS
          this.navCtrl.push(AddonsTriggerVersionProPage);
        } else {
          this.template = type;
        }
        break;
    }
  }

  selected() {
    this.template = "";
  }

  checkState(type) {
    if (this.template == type) {
      return true
    } else {
      return false
    }
  }

  async save() {
    if (this.template != '') {
      if (this.update_state) {
        //guardar plantilla y pop
        await this.menuServices.afs.collection('menus').doc(this.menu_uid).update({
          'template_name': this.template,
          'updated_at': new Date(),
        }).then(doc => {
          this.navCtrl.pop();
        });
      } else {
        this.createMenu();
      }
      this.globals.tourLaunchStep(3);
    } else {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('instant-selecciona-tipo-menu-continuar'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
    }
  }

  createMenu() {
    this.globals.GAtrackView('Menu', 'Menu - Select template - Create', this.globals.restaurant.email, 'Create/Update', 'Select template', 'Menu', this.translate.instant('general-titulo-menu'));
    this.menuServices.afs.collection('menus').add({
      'UID_RESTAURANT': this.globals.restaurant_uid,
      'style': 'basic',
      'separator': 'https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/separators%2Fseparador3.png?alt=media&token=1f0e9059-bd6a-49e8-a8e4-18c1e9ec3a11',
      'template': 'https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/templates%2Ffons_mct_blanc.png?alt=media&token=15455e42-1097-4eb0-bb47-1d29ef9622d5',
      'logo_show': true,
      'caption_show': false,
      'enumerate': false,
      'footer_show': true,
      'footer_font_color': '#000',
      'footer_font_family': 'Arial',
      'footer_font_size': '18',
      'footer_text_align': 'center',
      'header_font_color': '#000',
      'header_font_family': 'Arial',
      'header_font_size': '18',
      'header_text_align': 'center',
      'reference': '',
      'title_es': this.translate.instant('general-menu'),
      'title_en': this.translate.instant('general-menu'),
      'title_fr': this.translate.instant('general-menu'),
      'title_de': this.translate.instant('general-menu'),
      'title_it': this.translate.instant('general-menu'),
      'title_ca': this.translate.instant('general-menu'),
      'subtitle_es': '',
      'subtitle_en': '',
      'subtitle_fr': '',
      'subtitle_it': '',
      'subtitle_de': '',
      'subtitle_ca': '',
      'extra': 0,
      'price': 0,
      'extras_footer': [],
      'sections': {},
      'created_at': new Date(),
      'digital_app': true,
      'template_name': this.template,
      'type': 'menu',
      'tax': this.globals.RESTAURANT_TAX
    }).then(doc => {
      this.menu_uid = doc.id;
      if (this.update_state) {
        this.navCtrl.pop();
      } else {
        this.analyticsServices.trackingExp('starter', this.globals.tracking_exp['starter'], '');
        this.analyticsServices.trackingExp('crear menú', this.globals.tracking_exp['create_new_menu'], '');
        this.navCtrl.push(MenuCreateSelectTypePage, {
          update: this.update_state,
          menu_uid: this.menu_uid,
          show_prices: this.show_prices,
          new_menu: this.new_menu
        });
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/menu/menu-create/menu-create-select-template/menu-create-select-template.ts